module.exports = __webpack_public_path__ + "img/stock7.6542c484.png";